import styled from 'styled-components';
import { device } from '../../styles/devices';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Audi Type';
  font-size: 16px;
  padding-top: 24px;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  @media ${device.laptop} {
    flex-direction: row;
    align-items: flex-start;
    gap: 320px;
    flex-shrink: 0;
  }
`;

export const CTAWrapper = styled.div`
  width: 100%;

  @media ${device.laptop} {
    width: unset;
  }
`;
